import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'justonweb-accessibility-statement',
    templateUrl: './accessibility-statement.component.html',
    styleUrls: ['./accessibility-statement.component.scss'],
    standalone: false
})
export class AccessibilityStatementComponent implements OnInit {

  private scrollY = 0;

  constructor(
    private router: Router,
    ) { }

  ngOnInit() {
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    this.scrollY = window.pageYOffset;
  }
  isSticky() {
    return this.scrollY > 144;
  }

  goToHome() {
    this.router.navigate(["/"]);
  }

}

